import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { FULL_DATE_TIME } from '@ergonauts/ergo-algo-react/core/constants';
import { Typography } from '@mui/material';

// API
import { getPerson, listEvaluations } from '../../../api';

// Redux
import { setError } from '../../../alerts';

// Components
import { Button, Table } from '@lexcelon/react-util';

// Icons
import VisibilityIcon from '@mui/icons-material/Visibility';

import { enumToDisplayString } from '@ergonauts/ergo-algo-react/core/util';

const COLUMNS = [
  {
    title: 'View',
    render: rowData => (
      <Link to={'/evaluations/' + rowData.getId()}><VisibilityIcon /></Link>
    ),
  },
  {
    title: 'Scheduled Date/Time',
    render: rowData => rowData?.getScheduledDateTime()?.toLocaleString(FULL_DATE_TIME),
    customFilterAndSearch: (term, rowData) => rowData?.getScheduledDateTime()?.toLocaleString(FULL_DATE_TIME)?.toLowerCase()?.includes(term?.toLowerCase()),
    customSort: (a, b) => a.getScheduledDateTime() - b.getScheduledDateTime()
  },
  {
    title: 'Segment',
    render: rowData => rowData?.getSegment()?.getName(),
    customFilterAndSearch: (term, rowData) => rowData?.getSegment()?.getName()?.toLowerCase()?.includes(term?.toLowerCase()),
    customSort: (a, b) => a.getSegment()?.getName()?.localeCompare(b.getSegment()?.getName())
  },
  {
    title: 'Evaluee',
    render: rowData => rowData?.getEvaluee()?.getFullName(),
    customFilterAndSearch: (term, rowData) => rowData?.getEvaluee()?.getFullName()?.toLowerCase()?.includes(term?.toLowerCase()),
    customSort: (a, b) => a.getEvaluee()?.getFullName()?.localeCompare(b.getEvaluee()?.getFullName())
  },
  {
    title: 'Evaluee Email',
    render: rowData => rowData?.getEvaluee()?.getEmail(),
    customFilterAndSearch: (term, rowData) => rowData?.getEvaluee()?.getEmail()?.toLowerCase()?.includes(term?.toLowerCase())
  },
  {
    title: 'Address',
    render: rowData => rowData?.getAddress()?.getFullAddress(),
    customFilterAndSearch: (term, rowData) => rowData?.getAddress()?.getFullAddress()?.toLowerCase()?.includes(term?.toLowerCase()),
  },
  {
    title: 'Status',
    render: rowData => {
      switch (rowData?.getStatus()) {
        case 'SCHEDULED':
          return 'Waiting for Evaluee to Accept Invitation (Emailed)';
        case 'ACCEPTED':
          return 'Ready for Evaluation';
        default:
          return enumToDisplayString(rowData?.getStatus());
      }
    },
    customFilterAndSearch: (term, rowData) => rowData?.getStatus()?.toLowerCase()?.includes(term?.toLowerCase()),
    customSort: (a, b) => a.getStatus()?.localeCompare(b.getStatus())
  },
  {
    title: 'Group',
    render: rowData => rowData?.getGroup()?.getName(),
    customFilterAndSearch: (term, rowData) => rowData?.getGroup()?.getName()?.toLowerCase()?.includes(term?.toLowerCase()),
    customSort: (a, b) => a.getGroup()?.getName()?.localeCompare(b.getGroup()?.getName())
  },
];

class Evaluations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      evaluations: [],
      personId: null,
      isLoadingPerson: true,
      isLoadingEvaluations: false
    };
  }

  componentDidMount() {
    this.setState({ isLoadingEvaluations: true });
    listEvaluations().then(({ results }) => {
      if (results != null) {
        this.setState({ evaluations: results, isLoadingEvaluations: false });
      }
    }).catch((error) => {
      setError(error ?? 'Error: Could not retrieve evaluations.');
      this.setState({ isLoadingEvaluations: false });
    });

    this.setState({ isLoadingPerson: true });
    getPerson().then(person => {
      this.setState({ person, isLoadingPerson: false });
    }).catch(error => {
      setError(error ?? 'Error: Unable to get user.');
      this.setState({ isLoadingPerson: false });
    });
  }

  render() {
    return (
      <div style={{ margin: '2em' }}>
        <Typography variant='h1' style={{ textAlign: 'center', marginBottom: '1em', marginTop: '1.5em' }}>Evaluations</Typography>
        <Table
          title={
            <Button component={Link} to={'/evaluations/schedule?evaluatorId=' + this.state.person?.getId()} style={{ width: 200 }} isLoading={this.state.isLoadingPerson} disabled={this.state.person == null}>Schedule New</Button>
          }
          data={this.state.evaluations}
          columns={COLUMNS}
          isLoading={this.state.isLoadingEvaluations}
          options={{
            pageSize: 20
          }}
        />
      </div>
    );
  }
}

Evaluations.propTypes = {
  match: PropTypes.object.isRequired
};

export default withRouter(Evaluations);
